import type { CSSObject } from '@emotion/react'
import { Spacing, Typography } from '@opallabs/gem'

export const logIn: CSSObject = {
  ...Typography.T500,
  marginInlineEnd: Spacing.M * 2.75,
  textAlign: 'end',
}
